module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "popup-content"
  }, [_c('div', {
    staticClass: "line-one"
  }), _vm._v(" "), _c('div', {
    staticClass: "line-two"
  }), _vm._v(" "), _c('scroller', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "snapping": _vm.snapping,
      "size": _vm.size,
      "positionY": _vm.positionY,
      "autoResize": false
    },
    on: {
      "on-scrollend": _vm.scrollEnd
    }
  }, [_c('ul', {
    staticClass: "popup-ul",
    attrs: {
      "id": _vm.containerId
    }
  }, _vm._l((_vm.dataList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "popup-li"
    }, [_vm._v(_vm._s(item))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "sel-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "sel-bottom"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63ff4760","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/basic/components/common/selectScroll.vue
// module id = 356
// module chunks = 0